interface ZoomOutIconProps {
  color: string
  width?: number
  height?: number
}

const ZoomOutIcon = ({ color, width = 24, height = 24 }: ZoomOutIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <path
        fillRule="evenodd"
        fill={color}
        d="M11 2a9 9 0 0 1 7.032 14.617l3.675 3.676a1 1 0 0 1-1.32 1.497l-.094-.083-3.676-3.675A9 9 0 1 1 11 2m0 2a7 7 0 1 0 0 14 7 7 0 0 0 0-14m3 6a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2z"
      />
    </svg>
  )
}

export default ZoomOutIcon
